export default __webpack_public_path__ + "static/hammer_w.85c09886433ef39d85669b67531b3e8d.png";